"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomStepper = exports.CustomStepLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _Stepper = _interopRequireDefault(require("@material-ui/core/Stepper"));
var _StepLabel = _interopRequireDefault(require("@material-ui/core/StepLabel"));
var _StepConnector = _interopRequireDefault(require("@material-ui/core/StepConnector"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["children"],
  _excluded2 = ["children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ColorlibConnector = (0, _withStyles.default)(function (theme) {
  return {
    alternativeLabel: {
      top: 18
    },
    active: {
      "& $line": {
        borderColor: theme.palette.primary.main,
        borderStyle: 'solid',
        borderWidth: 3
      }
    },
    completed: {
      "& $line": {
        borderColor: theme.palette.primary.main,
        borderStyle: 'solid',
        borderWidth: 3
      }
    },
    line: {
      height: 0,
      borderRadius: 1,
      border: "3px dashed #eaeaf0"
    }
  };
})(_StepConnector.default);
var useColorlibStepIconStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#fff",
      width: 40,
      height: 40,
      display: "flex",
      borderRadius: 90,
      justifyContent: "center",
      alignItems: "center",
      '& .MuiSvgIcon-root': {
        fontSize: '1.4rem'
      }
    },
    active: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    completed: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    }
  };
});
function ColorlibStepIcon(props) {
  var _classNames;
  var classes = useColorlibStepIconStyles();
  var active = props.active,
    completed = props.completed;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.active, active), _defineProperty(_classNames, classes.completed, completed), _classNames))
  }, props.displayIcon);
}
var CustomStepper = function CustomStepper(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Stepper.default, _extends({
    alternativeLabel: true,
    connector: /*#__PURE__*/_react.default.createElement(ColorlibConnector, null)
  }, props), children);
};
exports.CustomStepper = CustomStepper;
var CustomStepLabel = function CustomStepLabel(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_StepLabel.default, _extends({}, props, {
    StepIconComponent: function StepIconComponent(colorLibStepIconProps) {
      return /*#__PURE__*/_react.default.createElement(ColorlibStepIcon, _extends({}, colorLibStepIconProps, {
        displayIcon: props.getIcon(props.icon)
      }));
    }
  }), children);
};
exports.CustomStepLabel = CustomStepLabel;